import styled from 'styled-components';

import Button from '~/src/common/components/Button';

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PlusButton = styled(Button)`
  width: 24px;
  height: 24px;

  border-radius: 4px;

  &[disabled] {
    cursor: not-allowed;
    background: ${({ theme }) => theme.palette.common.DISABLED};
    color: ${({ theme }) => theme.palette.common.WHITE};
    border-color: ${({ theme }) => theme.palette.common.DISABLED};

    &:hover {
      background: ${({ theme }) => theme.palette.common.DISABLED};
      color: ${({ theme }) => theme.palette.common.WHITE};
      border-color: ${({ theme }) => theme.palette.common.DISABLED};
    }
  }

  /* Necessary on Safari mobile */
  min-width: unset;
  padding-right: 0;
  padding-left: 0;
`;

export const MinusButton = styled(PlusButton)`
  border-color: ${({ theme }) => theme.palette.common.BACKGROUND_3};

  &[disabled] {
    &:hover {
      background: ${({ theme }) => theme.palette.common.WHITE};
      color: ${({ theme }) => theme.palette.common.DISABLED};
    }
  }
`;

export const Value = styled.span`
  width: 32px;

  font-size: 16px;
  line-height: 16px;
  font-weight: 500;
  text-align: center;
`;
